import { render, staticRenderFns } from "./select-tips.vue?vue&type=template&id=22a6477e"
import script from "./select-tips.vue?vue&type=script&lang=js"
export * from "./select-tips.vue?vue&type=script&lang=js"
import style0 from "./select-tips.vue?vue&type=style&index=0&id=22a6477e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports